<template>
    <vue-pikaday
        v-model="innerValue"
        v-bind="properties"
        class="form-control my-1"
        :options="pikadayOptions"
        :name="name"
    >
    </vue-pikaday>
</template>

<script>
    import ValueForwarder from '~/mixins/value-forwarder'
    import { PikadayOptions } from "~/Form/elements";

    export default {
        name: 'ad-datepicker',
        mixins: [
            ValueForwarder,
        ],

        data() {
            return {
                pikadayOptions: PikadayOptions
            }
        },

        props: {
            name: {
                required: true,
            },
            properties: {
                required: false,
                default: () => {
                    return {};
                },
            },
            value: {
                required: false,
                default: null,
            },
            options: {
                required: false,
            },
            trajectoryEnrolment: {
                type: Object,
                required: false,
            },
            actionProgress: {
                type: Object,
                required: false,
            },
            actionProgressId: {
                type: Number,
                required: false,
            },
            check: {
                type: Boolean,
                default: false,
            },
            checkId: {
                type: Number,
                required: false,
            },
        },

        watch: {
            value(newVal, oldVal) {
                this.$emit('input', newVal);
            }
        },

        mounted() {
            if (this.name === 'DJ6kSMcl0H' && (this.innerValue === '' || this.innerValue == null || this.innerValue === undefined)) {
                this.retrieveReport();
            }
        },
    };
</script>

<style scoped>

</style>
